export default {"src":"/_next/static/media/retail_foyer.0df6d9a1.svg","height":89,"width":326,"blurWidth":0,"blurHeight":0};